

















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ConfirmComponent extends Vue {
    @Prop()
    title?: string;

    @Prop()
    body?: string;

    @Prop()
    confirmLabel?: string;

    @Prop()
    confirmClass?: string;

    @Prop()
    cancelLabel?: string;

    @Prop()
    cancelClass?: string;
}
